import { Breakpoint } from "../css/maker.breakpoints";
import { useMatchMedia } from "./match-media";

/**
 * uses the matchMedia hook under the hood to determine if the given breakpoint
 * is matched by the user's device
 *
 * note that during SSR this hook falls back to checking if the given
 * breakpoint matches an ordinary desktop device size, which is helpful as it
 * ensures that any conditionally rendered content will reflect a desktop
 * layout when flushing crawlable html from the next.js server side layer
 *
 * if options.immediate is set to true, then the matching of the mediaQuery
 * will be applied immediately. This means that inconsistensies between client
 * and server WILL happen and is such this argument should ever only be used
 * inside code that is exclusively executed on the client.
 */
export function useMatchBreakpoint(
  breakpoint: Breakpoint,
  options?: { immediate?: boolean },
): boolean | undefined {
  return useMatchMedia(breakpoint.toQuery(), options);
}
